<template>
    <div class="container-fluid">
        <div class="row page-titles">
            <div class="col-sm-3 col-lg-4 align-self-center">
                <h4 class="text-themecolor">Home</h4>
            </div>
        </div>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="input-group form-group" v-if="this.$store.getters.isAdmin">
                            <label>User</label>
                            <treeselect placeholder="All"
                                        v-model="filter.userId"
                                        :multiple="false"
                                        :options="userList"
                                        :load-options="loadUserList"
                                        :auto-load-root-options="true"
                            />
                        </div>
                    </div>
                </div>
                <div class="card border-dark mb-3">
                    <div class="card-header">Profit dynamics
                        <button type="button" class="close mb-1" aria-label="Close">
                            <i class="fas fa-sync mr-1" aria-hidden="true"
                               @click="getProfitData()" style="font-size: 12px;"></i>
                        </button>
                    </div>
                    <div class="card-body text-dark">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{preloader: loading}"></Preloader>
                        </div>
                        <div v-else>
                            <div class="table-responsive">
                                <table class="table" v-if="profitData.this">
                                    <thead>
                                        <tr>
                                            <th class="border-top-0"></th>
                                            <th class="border-top-0">Month</th>
                                            <th class="border-top-0">Week</th>
                                            <th class="border-top-0">Day</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="align-middle">This</td>
                                            <td class="align-middle">{{profitData.this.month}}</td>
                                            <td class="align-middle">{{profitData.this.week}}</td>
                                            <td class="align-middle">{{profitData.this.day}}</td>
                                        </tr>
                                        <tr>
                                            <td class="align-middle">Last</td>
                                            <td class="align-middle">{{profitData.last.month}}</td>
                                            <td class="align-middle">{{profitData.last.week}}</td>
                                            <td class="align-middle">{{profitData.last.day}}</td>
                                        </tr>
                                        <tr>
                                            <td class="align-middle">Daily dynamic in %</td>
                                            <td class="align-middle">{{profitData.diff.month}}</td>
                                            <td class="align-middle">{{profitData.diff.week}}</td>
                                            <td class="align-middle">{{profitData.diff.day}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Preloader from '../components/Preloader';
    import ReportService from '../services/ReportService';
    import UserService from '../services/UserService';
    import Swal from 'sweetalert2';
    import Treeselect from '@riophae/vue-treeselect';

    export default {
        name: 'ProfitReport',
        components: {
            Treeselect,
            Preloader
        },
        data() {
            return {
                profitData: [],
                userList: null,
                filter: {
                    userId: null
                },
                loading: false
            }
        },
        mounted() {
            this.getProfitData();
        },
        methods: {
            loadUserList({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userList = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            },
            getProfitData: function () {
                this.loading = true;
                ReportService.getProfitData(JSON.stringify(this.filter)).then(response => {
                    if (response.status !== 200) {
                        Swal({
                            type: 'error',
                            title: 'Error',
                            text: (response.data.error === undefined) ? response.status + ': ' + response.statusText : response.data.error[0]
                        });
                        this.loading = false;
                        return;
                    }
                    this.profitData = response.data.data;
                    this.loading = false;
                }).catch(error => {
                    Swal({
                        type: 'error',
                        title: 'Oops...',
                        text: `${error}`,
                    });
                    this.loading = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>
